
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"60","viewBox":"0 0 226 60","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M133.588 25.815c2.124-2.038 3.398-4.926 3.398-8.07 0-6.115-4.927-11.126-11.042-11.211h-12.402v38.563h12.402c6.115-.085 11.042-5.096 11.042-11.212 0-3.143-1.274-6.031-3.398-8.07zm-13.59-12.826h5.776c2.633 0 4.841 2.124 4.841 4.842 0 2.718-2.123 4.842-4.756 4.842h-5.776zm5.776 25.738h-5.776v-9.599h5.776c2.633 0 4.756 2.124 4.756 4.842 0 2.718-2.123 4.757-4.756 4.757zM189.82 6.619h-8.07l-7.644 22.51v16.053h6.455v-9.598h10.618v9.598h6.456V29.128zm-4.077 7.984l4.926 14.44h-9.853zm40.177-5.606l-8.834 20.046v16.054h-6.455V29.043l-8.834-20.046V6.619h5.946l6.116 13.845 6.115-13.845h5.946zM73.45 33.715c0 6.626-5.437 12.062-12.062 12.062-6.626 0-12.062-5.436-12.062-12.062v-4.672h6.455v4.672c0 3.058 2.549 5.606 5.607 5.606 3.057 0 5.606-2.548 5.606-5.606V6.619h6.455zM93.495 5.939c-6.626 0-12.062 5.436-12.062 12.062v15.714c0 6.626 5.436 12.062 12.062 12.062 6.625 0 12.061-5.436 12.061-12.062V18.001c0-6.626-5.436-12.062-12.061-12.062zm5.606 12.062v15.714c0 3.058-2.548 5.606-5.606 5.606s-5.607-2.548-5.607-5.606V18.001c0-3.058 2.549-5.606 5.607-5.606 3.058 0 5.606 2.548 5.606 5.606zm58.27-11.382H145.65v38.563h6.456v-15.12h5.266c6.456 0 11.722-5.266 11.722-11.721 0-6.456-5.266-11.722-11.722-11.722zm0 16.988h-5.266V12.989h5.266c2.888 0 5.266 2.379 5.266 5.267 0 2.888-2.378 5.35-5.266 5.35zM36.5 55.545H6.004V49.09H36.5zm-6.286-28.2l-5.776 7.39V6.618h-6.456v28.115l-5.776-7.39H5.92v2.379l12.062 15.374h6.456l12.061-15.374v-2.379z"}})])
          )
        }
      }
    